import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MessagingTemplateModel} from '../../api/models';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ProMessagingTemplateEditComponent } from '../edit/edit.component';

@Component({
    selector: 'app-edit-template-dialog',
    template: `
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
      <div fxFlex>Edit Template</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <div mat-dialog-content style="padding: 0">
      <app-pro-messaging-template-edit [id]="data.editId" (afterSaveOrDelete)="afterSaveOrDelete($event)"></app-pro-messaging-template-edit>
    </div>
  `,
    styles: [],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, ProMessagingTemplateEditComponent]
})
export class EditTemplateDialogComponent implements OnInit, OnDestroy {


  constructor(public dialogRef: MatDialogRef<EditTemplateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  afterSaveOrDelete(dataItem: MessagingTemplateModel) {
    this.dialogRef.close(dataItem);
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }
}
